import { defineMessages } from 'react-intl';

export default defineMessages({
  labelSignUpGoogle: {
    id: 'Sign up with Google',
    defaultMessage: 'Sign up with Google'
  },
  labelSignUpFacebook: {
    id: 'Sign up with Facebook',
    defaultMessage: 'Sign up with Facebook'
  },
  labelLinkForgotPassword: {
    id: 'Have you forgotten?',
    defaultMessage: 'Have you forgotten?'
  },
  labelLinkHaveAccount: {
    id: 'Already have an account? Connect',
    defaultMessage: 'Already have an account? Connect'
  },
  labelLinkRecoverPassword: {
    id: 'Recover password',
    defaultMessage: 'Recover password'
  },
  divider: {
    id: 'OR',
    defaultMessage: 'OR'
  },
  labelAcceptTerms: {
    id: 'Clicking on register, you accept the',
    defaultMessage: 'Clicking on register, you accept the'
  },
  labelTerms: {
    id: 'Terms and condiciones',
    defaultMessage: 'Terms and condiciones'
  },
  signInUserURL: {
    id: 'signInUserURL',
    defaultMessage: '#'
  }
});
